import { Component, ElementRef, ViewChild } from "@angular/core";
import { GenreService } from "src/app/services/genre.service";

@Component({
  selector: "app-genre-unveiled",
  templateUrl: "./genre-unveiled.component.html",
  styleUrls: ["./genre-unveiled.component.scss"],
})
export class GenreUnveiledComponent {
  @ViewChild("scrollContent") scrollContent!: ElementRef;

  scrollSpeed = 200;

  genrelist = [
    { id: "learn-flute-online", name: "Flute" },
    { id: "bharatnatyam-online-classes", name: "Bharatnatyam" },
    { id: "keyboard-online-classes", name: "Keyboard" },
    { id: "learn-harmonium-online", name: "Harmonium" },
    { id: "online-guitar-classes", name: "Guitar" },
    { id: "carnatic-vocal-classes", name: "Carnatic Vocal" },
    { id: "hindustani-vocal-classes", name: "Hindustani Classical Vocal" },
    { id: "online-sitar-classes", name: "Sitar" },
    { id: "kathak-dance-online-classes", name: "Kathak" },
    { id: "online-theatre-courses", name: "Theatre" },
    { id: "tabla-classes-online", name: "Tabla" },
  ];
  constructor(private genre: GenreService) {}

  getImage(genre: string) {
    let imageURL = genre.replace(/ /g, "_").toLowerCase();
    imageURL =
      "https://d2abnqj5vuy2s4.cloudfront.net/assets/images/genre/" +
      imageURL +
      ".png";
    return imageURL;
  }

  scrollLeft() {
    this.scrollContent.nativeElement.scrollTo({
      left: this.scrollContent.nativeElement.scrollLeft - this.scrollSpeed,
      behavior: "smooth",
    });
  }

  scrollRight() {
    this.scrollContent.nativeElement.scrollTo({
      left: this.scrollContent.nativeElement.scrollLeft + this.scrollSpeed,
      behavior: "smooth",
    });
  }
}
